require('intersection-observer');

import Vue from 'vue'
import App from './App.vue'
import '@/assets/scss/main.scss';
import router from './router'

// import VueParallaxJs from 'vue-parallax-js'
// Vue.use(VueParallaxJs)
import LoadScript from 'vue-plugin-load-script';
Vue.use(LoadScript);
import inViewportDirective from 'vue-in-viewport-directive'
Vue.directive('in-viewport', inViewportDirective)

Vue.config.productionTip = false

import {
  isMobile
} from '@/js/isMobile.js';

new Vue({
  router,
  created() {
    let vh = window.innerHeight * 0.01;
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty('--vh', `${vh}px`);
    window.addEventListener("resize", this.resizeEvent);
  },
  destroyed() {
    window.removeEventListener("resize", this.resizeEvent);
  },
  methods: {
    resizeEvent(e) {
      let vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
      this.isMobile = isMobile()
    }
  },
  data() {
    return {
      isMobile: isMobile()
    }
  },
  render: h => h(App)
}).$mount('#app')